import React, {Component, PropTypes} from "react";
import {Modal} from "react-bootstrap";
import {IS_IN_MOBILE_MODE, RESOURCE_BASE_URL} from "../../../../configuration";
import axios from 'axios';
import parse from 'html-react-parser';
import './PrintOrder.css';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import PriceLoadingImage from "../../../../assets/img/loading_price.gif";

class PrintOrder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            evaluatedTemplate: '',
            pdfFile: '',
            itemData: [],
            language: localStorage.getItem("setLang"),
            generating : false,
            showMobileInvoiceModal : false,
            showMobileInvoiceModalError : false
        };
        this.getPebbleTemplate = this.getPebbleTemplate.bind(this);
        this.printDocument = this.printDocument.bind(this);
        this.downloadDocument = this.downloadDocument.bind(this);
        this.getLanguageLocale = this.getLanguageLocale.bind(this);
        this.downloadMobileViewDocument = this.downloadMobileViewDocument.bind(this);
        this.getMobileViewPebbleTemplate = this.getMobileViewPebbleTemplate.bind(this);
        this.handleCloseMobileInvoiceModal = this.handleCloseMobileInvoiceModal.bind(this);
        this.handleCloseMobileInvoiceModalError = this.handleCloseMobileInvoiceModalError.bind(this);

    }

    handleClose = () => {
        this.setState({show: false});
    };
    handleCloseMobileInvoiceModal = () => {
        this.setState({showMobileInvoiceModal: false});
    };
    handleCloseMobileInvoiceModalError = () => {
        this.setState({showMobileInvoiceModalError: false});
    };

    handleShow = () => {
        this.setState({
            show: true,
            language:  localStorage.getItem("setLang")
        });

        this.getLanguageLocale();
        this.getPebbleTemplate();
    };

    getLanguageLocale = () => {
        localStorage.getItem("setLang");
        this.setState({
            language:  localStorage.getItem("setLang")
        });

        /*if(localStorage.getItem("setLang")==="en"){
            this.setState({language:"en"})
        }
        if(localStorage.getItem("setLang")==="ja"){
            this.setState({language:"ja"})
        }*/
    };

    getPebbleTemplate = () => {
        if(this.state.evaluatedTemplate === ''){
            this.setState({
                generating : true
            });
        }
        axios.get(RESOURCE_BASE_URL + 'api/orders/' + this.props.orderId + '/invoice/' + InitialQuotationState.lang+'/'+this.props.orderStat)
            .then((res) => {
                this.setState({
                    evaluatedTemplate: res.data.evaluatedTemplate,
                    pdfData : res.data.pdfData,
                    generating : false
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({
                    generating : false
                })
            });
    };

    getMobileViewPebbleTemplate = () => {
        this.setState({
            generating : true,
            showMobileInvoiceModal : true

        });
        axios.get(RESOURCE_BASE_URL + 'api/orders/' + this.props.orderId + '/invoice/' + InitialQuotationState.lang+'/'+this.props.orderStat)
            .then((res) => {
                this.setState({
                    evaluatedTemplate: res.data.evaluatedTemplate,
                    pdfData : res.data.pdfData,
                    generating : false,
                    showMobileInvoiceModal : false
                }, ()=>this.downloadMobileViewDocument());
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({
                    generating : false,
                    showMobileInvoiceModal : false,
                    showMobileInvoiceModalError : true
                })
            });
    };

    downloadDocument() {
        fetch("data:application/pdf;base64," + this.state.pdfData)
            .then((resp) => {
                return resp.blob()
            })

            .then((blob) => {

                const fileURL = URL.createObjectURL(blob);
                let fileLink = document.createElement('a');
                fileLink.href = fileURL;

                let today = new Date();
                let date = today.getFullYear().toString() + (today.getMonth()+1).toString().padStart(2, "0") + today.getDate().toString().padStart(2, "0");
                let time = today.getHours().toString().padStart(2, "0") + today.getMinutes().toString().padStart(2, "0") + today.getSeconds().toString().padStart(2, "0");

                fileLink.download = "B"+this.props.batchNumber.substring(1);
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);


            });
    }

    downloadMobileViewDocument = () => {
        fetch("data:application/pdf;base64," + this.state.pdfData)
            .then((resp) => {
                return resp.blob()
            })

            .then((blob) => {

                const fileURL = URL.createObjectURL(blob);
                let fileLink = document.createElement('a');
                fileLink.href = fileURL;

                let today = new Date();
                let date = today.getFullYear().toString() + (today.getMonth()+1).toString().padStart(2, "0") + today.getDate().toString().padStart(2, "0");
                let time = today.getHours().toString().padStart(2, "0") + today.getMinutes().toString().padStart(2, "0") + today.getSeconds().toString().padStart(2, "0");

                fileLink.download = "B"+this.props.batchNumber.substring(1);
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);


            });
    };

    printDocument() {
        fetch("data:application/pdf;base64," + this.state.pdfData)
            .then((resp) => {
                return resp.blob()
            })

            .then((blob) => {
                const fileURL = URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                window.open(fileURL, "_blank").print();
            });
    }

    render() {
// console.log("ORDER EVE TEMP =====> ",this.state.evaluatedTemplate);
        return (
            <span>
            <a hidden={IS_IN_MOBILE_MODE} className="view-act-btn no-padding " onClick={this.handleShow}>
            <FormattedMessage id="app.print-order.invoice"
                              defaultMessage="Invoice"
                              description=""/>
            </a>
                 <a className="view-act-btn no-padding" hidden={!IS_IN_MOBILE_MODE} onClick={this.getMobileViewPebbleTemplate}>
              <FormattedMessage id="app.print-order.invoice"
                                defaultMessage="Invoice"
                                description=""/>
                </a>
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-90w">
            <Modal.Header closeButton>
               {/* <div className="title-1 color-text">
                    <FormattedMessage id="app.print-order.print-title"
                                      defaultMessage="Quotation Data"
                                      description=""/>
                     :&nbsp;&nbsp;<FormattedMessage id="app.print-order.print-title2"
                                                    defaultMessage="ORDER #"
                                                    description=""/>
                    {this.props.orderId}
                </div>*/}
            </Modal.Header>
            <Modal.Body>
                {this.state.generating === true ?
                    <div className="text-center">
                        <img className="generating-invoice" src={PriceLoadingImage} alt="請求書の生成。お待ちください。。"/><br/><br/>
                        <h4>少し、お待ち下さい。</h4>
                    </div> : ""
                }
                <div id="print-modal">
                      {parse(this.state.evaluatedTemplate)}
                </div>

            </Modal.Body>
            <Modal.Footer>
                {this.state.evaluatedTemplate !== '' ?
                    <div className="delete-cart-item-div">
                        <button className="btn download-btn-inv" onClick={this.downloadDocument}>
                            <FormattedMessage id="app.print-order.download"
                                              defaultMessage="Download"
                                              description=""/>
                        </button>
                        <button className="btn print-btn-inv" onClick={this.printDocument}>
                            <FormattedMessage id="app.print-order.print"
                                              defaultMessage="Print"
                                              description=""/>
                        </button>

                    </div> : ""
                }

            </Modal.Footer>
        </Modal>
                {/*==================================== mobile processing modal ==============================*/}

                <Modal show={this.state.showMobileInvoiceModal} onHide={this.handleCloseMobileInvoiceModal} dialogClassName="modal-90w-mobile-quotation">
            <Modal.Header closeButton>

            </Modal.Header>
            <Modal.Body>
                 <div className="text-center">
                        <img className="generating-invoice" src={PriceLoadingImage} alt="請求書の生成。お待ちください。。"/><br/><br/>
                        <h5>請求書・領収書をデバイスに保存中。</h5>
                    </div>

            </Modal.Body>
            <Modal.Footer>


            </Modal.Footer>
        </Modal>

                {/*==================================== mobile processing modal error ==============================*/}

                <Modal show={this.state.showMobileInvoiceModalError} onHide={this.handleCloseMobileInvoiceModalError} dialogClassName="modal-90w-mobile-quotation">
            <Modal.Header closeButton>

            </Modal.Header>
            <Modal.Body>
                 <div className="text-center">
                        <h4>現在、請求書を生成できません。後でもう一度やり直してください。</h4>
                    </div>

            </Modal.Body>
            <Modal.Footer>
                <button className="pull-right btn btn-primary" onClick={this.handleCloseMobileInvoiceModalError}>閉じる</button>

            </Modal.Footer>
        </Modal>
        </span>
        )
    }

}

export default PrintOrder;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/PrintOrder.js